import { useState } from "react";

// Components
import { IcomDropdown } from "src/components/icom-dropdown";
import SidePanel from "./panel";

// Types
import { Option } from "src/components/icom-dropdown";
import FinishStatus from "src/models/finish-status";

const PanelStatus = ({
  togglePanel,
  setStatus,
  statusList,
  selectedStatus,
}: {
  togglePanel: Function;
  setStatus: Function;
  statusList: Array<FinishStatus>;
  selectedStatus: string | null | undefined;
}) => {
  // Create mini state
  const [state, setState] = useState({
    selectedStatus: selectedStatus,
    submiting: false,
  });

  // Map status to Option pattern
  const listOptions: Array<{ id: string; label: string; value: string }> =
    statusList?.map((s) => ({
      id: s.id,
      label: s.status,
      value: s.status,
    })) || [];

  const setStatusHandler = async (selectedStatus: string) => {
    setState((s) => ({ ...s, submiting: true }));
    await setStatus(selectedStatus);
    setState((s) => ({ ...s, submiting: false }));
  };

  return (
    <SidePanel panelName="Status" toggleAction={togglePanel}>
      <div className="flex flex-col justify-between h-full">
        <IcomDropdown selectedOption={selectedStatus} onChange={(option: Option) => setState((s) => ({ ...s, selectedStatus: option.label }))} listOptions={listOptions} />

        <button
          disabled={!state.selectedStatus || state.submiting}
          onClick={() => state.selectedStatus && setStatusHandler(state.selectedStatus)}
          className="h-12 bg-primary-blue-400 text-base font-bold text-white flex items-center justify-center rounded-lg hover:bg-primary-blue-500 disabled:bg-gray-300 disabled:text-gray-400"
          type="button"
        >
          {state.submiting ? "Avaliando..." : "Avaliar"}
        </button>
      </div>
    </SidePanel>
  );
};

export default PanelStatus;
